import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { PromoBanner } from "@/components/PromoBanner";
import { MarqueeStrip } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { AppDownload } from "@/components/AppDownload";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App min-h-screen bg-background text-foreground overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <PromoBanner />
          <MarqueeStrip />
          <Manifesto />
          <Services />
          <Team />
          <Testimonials />
          <AppDownload />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
